// Dependencies
import React from 'react';
import ReactDOM from 'react-dom';

// Components
import MinicartApp from './containers/App';

// Utils
import { REACT_APP_ROOT } from './utils/config';

// Stylesheets
import './assets/stylesheets/main.scss';

ReactDOM.render(
	<React.StrictMode>
		<MinicartApp />
	</React.StrictMode>,
REACT_APP_ROOT);
